<i18n>
{
	"en": {
		"addFilter": "Add filter",
		"advancedSearch": "Advanced Search",
		"allLocations": "All locations",
		"consigneeReference": "Consignee Reference",
		"customersReference": "Customers Reference",
		"economicalStatus": "Economical Status",
		"economicalStatusSelected": "All economical status | {count} economical status selected | {count} economical status selected",
		"editSearch": "Edit search",
		"fromDespatchParty": "Despatch Party",
		"goodsTypes": "Goods Types",
		"incomplete": "Incomplete",
		"invoiced": "Invoiced",
		"loading": "Loading...",
		"notPickedUp": "Not Picked Up",
		"notSettled": "Not Settled",
		"numberOfPallets": "Pallets",
		"onlyPickedUp": "Only Picked Up",
		"orderType": "Order Type",
		"pickupStatus": "Pickup Status",
		"poReference": "PO Reference",
		"recorded": "Recorded",
		"references": "References",
		"referencesSelected": "All references | {count} reference selected | {count} references selected",
		"resetSearch": "Reset Search",
		"saveSearch": "Save this search",
		"search": "Search",
		"searchForLocation": "Search for location",
		"searchForOrders": "Orders",
		"searchPlaceholder": "Search text",
		"selectDate": "Select date",
		"selectEconomicalStatus": "Select economical status",
		"selectReferences": "Select references",
		"sendersReference": "Senders Reference",
		"settled": "Settled",
		"showAny": "Show Any",
		"status": "Status",
		"toDeliveryParty": "Delivery Party",
		"selectOrdersFromArea": "Select orders from area",
		"selectOrdersToArea": "Select orders to area",
		"failedToFetch": "Failed to search for orders",
		"searchAreas": "Address / Area",
		"lockMap": "Lock (Fixate) map to this area",
		"etd": "ETD",
		"eta": "ETA",
		"etx": "ETD / ETA",
		"selectOrderStatus": "Select Status",
		"orderStatusSelected": "All statuses | {count} status selected | {count} statuses selected",
		"cancelled": "Cancelled",
		"draft": "Draft",
		"received": "Received",
		"rejected": "Rejected",
		"ready": "Ready",
		"planned": "Planned",
		"unsuccessful": "Unsuccessful",
		"requested": "Requested",
		"accepted": "Accepted",
		"selectStatus": "Select status",
		"readyForPickup": "Ready for pickup",
		"loaded": "Loaded",
		"unloaded": "Unloaded",
		"onlyUnplanned": "Only Unplanned",
		"includePlanned": "Include Planned",
		"waybillNumber": "Waybill Number",
		"allWaybillNumbers": "All waybill numbers",
		"inboundEdiFilterLabel": "Only inbound EDI from",
		"inboundEdiFilterPlaceholder": "EDI from",
		"deviationFilterLabel": "Deviation",
		"fitToTrip": "Adjust/Fit to trip"
	},
	"no": {
		"addFilter": "Legg til filter",
		"advancedSearch": "Avansert søk",
		"allLocations": "Alle steder",
		"consigneeReference": "Mottakers referanse",
		"customersReference": "Kundereferanse",
		"economicalStatus": "Økonomisk status",
		"economicalStatusSelected": "Alle økonomisk statuser | {count} økonomisk status valgt | {count} økonomisk status valgt",
		"editSearch": "Rediger søket",
		"fromDespatchParty": "Henteaddresse",
		"goodsTypes": "Godstyper",
		"incomplete": "Ufullstendig",
		"invoiced": "Oppgjort",
		"loading": "Henter oppdrag...",
		"notPickedUp": "Ikke hentet",
		"notSettled": "Ikke klarert",
		"onlyPickedUp": "Bare hentet",
		"orderType": "Oppdragstype",
		"pickupStatus": "Hentestatus",
		"poReference": "PO referanse",
		"recorded": "Bokført",
		"references": "Referanser",
		"referencesSelected": "Alle referanser | {count} referanse valgt | {count} referanser valgt",
		"resetSearch": "Nullstill søk",
		"saveSearch": "Lagre dette søket",
		"search": "Søk",
		"searchForLocation": "Søk etter sted",
		"searchForOrders": "Oppdrag",
		"searchPlaceholder": "Søketekst",
		"selectDate": "Velg dato",
		"selectEconomicalStatus": "Velg økonomisk status",
		"selectReferences": "Velg referanser",
		"sendersReference": "Avsenders referanse",
		"settled": "Klarert",
		"showAny": "Vis alle",
		"toDeliveryParty": "Leveringsaddresse",
		"selectOrdersFromArea": "Velg ordre fra område",
		"selectOrdersToArea": "Velg ordre til område",
		"failedToFetch": "Kunne ikke søke etter ordre",
		"searchAreas": "Adresse / Område",
		"lockMap": "Lås kart til dette området",
		"etd": "ETD",
		"eta": "ETA",
		"etx": "ETD / ETA",
		"selectOrderStatus": "Velg status",
		"orderStatusSelected": "Alle statuser | {count} status valgt | {count} statuser valgt",
		"cancelled": "Annullert",
		"draft": "Kladd",
		"received": "Mottatt",
		"rejected": "Avslått",
		"ready": "Klar",
		"planned": "Planlagt",
		"unsuccessful": "Bomtur",
		"requested": "Forespurt",
		"accepted": "Akseptert",
		"selectStatus": "Velg status",
		"readyForPickup": "Klar for henting",
		"loaded": "Lastet",
		"unloaded": "Losset",
		"onlyUnplanned": "Kun uplanlagte",
		"includePlanned": "Inkluderer planlagt",
		"waybillNumber": "Fraktbrevnr",
		"allWaybillNumbers": "Alle fraktbrevnr",
		"inboundEdiFilterLabel": "Bare inngående EDI fra",
		"inboundEdiFilterPlaceholder": "EDI fra",
		"deviationFilterLabel": "Avvik",
		"fitToTrip": "Tilpass tur"
	}
}
</i18n>
<template>
	<div class="order-search-form">
		<div class="loadplanning-inner-menu-bar">
			<t-icon-button
				icon="list"
				iconSize="xs"
				appearance="minimal"
				type="bp"
				:disabled="!mapView"
				@click="onListView"
			/>
			<t-icon-button
				icon="globe"
				iconSize="xs"
				appearance="minimal"
				type="bp"
				:disabled="mapView"
				@click="onMapView"
			/>
		</div>
		<t-vertical-panel v-show="filtersVisible" class="order-search">

			<div slot="header" class="order-search-header">

				<OrderSearchFiltersHeader
					:items="savedSearches"
					:selectedItem="loadedSearch"
					width="100%"
					@change="onLoadSavedSearch"
					@toggleFilters="$emit('toggleFilters')"
				>
					<template>
						{{ loadedSearch.id === -1 ? $t('searchForOrders') : loadedSearch.label}}
					</template>

					<template v-slot:menuitemlabel="{item}">
						{{ item.labelKey ? $t(item.labelKey) : item.label }}
					</template>
				</OrderSearchFiltersHeader>
			</div>

			<div slot="sub-header" class="order-search-sub-header">
				<t-button
					:busy="ordersLoading"
					appearance="primary"
					@click="searchOrders"
				>
					{{ orderSearchText }}
				</t-button>
				<t-icon-button
					appearance="minimal"
					type="bp"
					icon="filter-keep"
					@click="$emit('saveSearch')"
				/>
			</div>

			<div class="order-search-content">
				<t-selectable-form-group
					:items="dateTypes"
					:selectedItem="searchFilter.dateType"
					horizontal
					@change="setSearchFilterDateType"
				>
					<template v-slot:label="{item}">
						{{ $t(item) }}
					</template>
					<template v-slot:menuitemlabel="{item}">
						{{ $t(item) }}
					</template>

					<t-date-picker
						ref="firstInput"
						:placeholder="$t('selectDate')"
						:dateFormat="displayDateFormat"
						:value="formatDate(searchFilter.date.from)"
						width="100%"
						relative
						@input="setSearchFilterDateFrom"
						@enter="searchOrders"
					/>
					<t-date-picker
						:placeholder="$t('selectDate')"
						:dateFormat="displayDateFormat"
						:value="formatDate(searchFilter.date.to)"
						width="100%"
						relative
						@input="setSearchFilterDateTo"
						@enter="searchOrders"
					/>
				</t-selectable-form-group>
				<t-form-group>
					<LocationsCombobox
						ref="searchAreas"
						:label="$t('searchAreas')"
						:placeholder="$t('searchForLocation')"
						:selected="searchFilter.searchAreas"
						:dialogTitle="$t('selectOrdersFromArea')"
						dialogType="searchAreas"
						width="100%"
						iconSize="sm"
						icon="geosearch"
						@input="inputs.searchAreas = $event"
						@select="onSelectSearchArea"
						@multiselect="setSearchAreas"
						@enter="searchOrders"
					/>
					<t-tag-container
						v-if="hasItems(searchFilter.searchAreas)"
						:items="searchFilter.searchAreas"
						displayKey="label"
						@change="setSearchAreas"
						@tag-click="changeTagOpCode({ key: 'searchAreas', tag: $event })"
					>
						<template v-slot="{ item }">
							<t-location-tag-inner :item="item" displayKey="label" />
						</template>
					</t-tag-container>
					<t-checkbox
						v-if="mapView"
						:label="$t('lockMap')"
						:checked="lockMap"
						:disabled="searchFilter.searchAreas.length === 0"
						@change="setValue({key: 'lockMap', value: $event})"
					/>
				</t-form-group>
				<t-form-group>
					<LocationsCombobox
						ref="fromDespatchParty"
						:label="$t('fromDespatchParty')"
						:placeholder="$t('searchForLocation')"
						:selected="searchFilter.fromDespatchParty"
						:dialogTitle="$t('selectOrdersFromArea')"
						dialogType="fromDespatchParty"
						width="100%"
						iconSize="sm"
						icon="geosearch"
						@input="inputs.fromDespatchParty = $event"
						@select="onSelectDespatchParty"
						@multiselect="setFromDespatchParty"
						@enter="searchOrders"
					/>
					<t-tag-container
						v-if="hasItems(searchFilter.fromDespatchParty)"
						:items="searchFilter.fromDespatchParty"
						displayKey="label"
						@change="setFromDespatchParty"
						@tag-click="changeTagOpCode({ key: 'fromDespatchParty', tag: $event })"
					>
						<template v-slot="{ item }">
							<t-location-tag-inner :item="item" displayKey="label" />
						</template>
					</t-tag-container>
					<t-checkbox
						:label="$t('fitToTrip')"
						:checked="fitDespatchPartyToTrip"
						@change="onChangeFitDespatchPartyToTrip"
					/>
				</t-form-group>
				<t-form-group>
					<LocationsCombobox
						ref="toDeliveryParty"
						:label="$t('toDeliveryParty')"
						:placeholder="$t('allLocations')"
						:selected="searchFilter.toDeliveryParty"
						:dialogTitle="$t('selectOrdersToArea')"
						dialogType="toDeliveryParty"
						width="100%"
						iconSize="sm"
						icon="geosearch"
						@input="inputs.toDeliveryParty = $event"
						@select="onSelectDeliveryParty"
						@multiselect="setToDeliveryParty"
						@enter="searchOrders"
					/>
					<t-tag-container
						v-if="hasItems(searchFilter.toDeliveryParty)"
						:items="searchFilter.toDeliveryParty"
						displayKey="label"
						@change="setToDeliveryParty"
						@tag-click="changeTagOpCode({ key: 'toDeliveryParty', tag: $event })"
					>
						<template v-slot="{ item }">
							<t-location-tag-inner :item="item" displayKey="label" />
						</template>
					</t-tag-container>
					<t-checkbox
						:label="$t('fitToTrip')"
						:checked="fitDeliveryPartyToTrip"
						@change="onChangeFitDeliveryPartyToTrip"
					/>
				</t-form-group>

				<t-form-group>
					<customer-search-input
						ref="customer"
						:selectedItems="searchFilter.customer"
						width="100%"
						@input="inputs.customer = $event"
						@change="addCustomerString"
						@select="addCustomer"
						@enter="searchOrders"
						@set:selected="setCustomer"
					/>
					<t-tag-container
						v-if="hasItems(searchFilter.customer)"
						:items="searchFilter.customer"
						displayKey="name"
						@change="setCustomer"
						@tag-click="changeTagOpCodeBetweenNotAndOr({ key: 'customer', tag: $event })"
					>
						<template v-slot="{ item }">
							<t-location-tag-inner :item="item" displayKey="name" />
						</template>
					</t-tag-container>
				</t-form-group>

				<t-form-group>
					<goods-types-select
						:label="$t('goodsTypes')"
						:selectedItems="searchFilter.goodsTypes"
						@change="addGoodsType"
					/>
					<t-tag-container
						v-if="hasItems(searchFilter.goodsTypes)"
						:items="searchFilter.goodsTypes"
						displayKey="name"
						@change="setGoodsType"
					/>
				</t-form-group>

				<t-form-group>
					<order-types-select
						:label="$t('orderType')"
						:selectedItems="searchFilter.orderTypes"
						relative
						@change="addOrderTypes"
					/>
					<t-tag-container
						v-if="hasItems(searchFilter.orderTypes)"
						:items="searchFilter.orderTypes"
						displayKey="name"
						@change="setOrderTypes"
					/>
				</t-form-group>

				<OperationalStatusFormInput
					:selectedItems="searchFilter.orderStatus"
					relative
					@change="addOrderStatus"
				>
					<template v-slot:displayedValue="{popoverShow}">
						{{ popoverShow ? $t('selectOrderStatus') : $tc('orderStatusSelected', searchFilter.orderStatus.length)}}
					</template>
					<template #after>
						<t-tag-container
							v-if="hasItems(searchFilter.orderStatus)"
							:items="searchFilter.orderStatus"
							@change="setOrderStatus"
						>
							<template v-slot="{item}">
								<div style="display: flex; align-items: center; justify-content: flex-start;">
									<t-status-color-dot :color="getStatusColor(item)"/>
									<div style="margin-left: 5px;">{{getStatusText(item)}}</div>
								</div>
							</template>
						</t-tag-container>
					</template>
				</OperationalStatusFormInput>

				<EconomicalStatusesFormInput
					:selectedItems="searchFilter.economicalStatus"
					relative
					@change="addEconomicalStatus"
				>
					<template v-slot:displayedValue="{popoverShow}">
						{{ popoverShow ? $t('selectEconomicalStatus') : $tc('economicalStatusSelected', searchFilter.economicalStatus.length)}}
					</template>
					<template #after>
						<t-tag-container
							v-if="hasItems(searchFilter.economicalStatus)"
							:items="searchFilter.economicalStatus"
							@change="setEconomicalStatus"
						>
							<template v-slot="{item}">
								<div style="display: flex; align-items: center; justify-content: flex-start;">
									<t-status-color-dot :color="getEconomicalStatusColor(item)"/>
									<div style="margin-left: 5px;">{{getEconomicalStatus(item)}}</div>
								</div>
							</template>
						</t-tag-container>
					</template>
				</EconomicalStatusesFormInput>

				<t-form-group>
					<t-select
						:items="[false,true]"
						:label="$t('planned')"
						:selectedItem="searchFilter.planned"
						width="100%"
						relative
						@change="setPlanned"
					>
						<template v-slot:displayedValue>
							{{ searchFilter.planned ? $t('includePlanned') : $t('onlyUnplanned') }}
						</template>
						<template v-slot:optionItemValue="slotProps">
							{{slotProps.item ? $t('includePlanned') : $t('onlyUnplanned')}}
						</template>
					</t-select>
				</t-form-group>

				<t-form-group>
					<t-select
						:items="hasAtdItems"
						:label="$t('pickupStatus')"
						:selectedItem="searchFilter.hasAtd"
						width="100%"
						displayName="label"
						relative
						@change="setHasAtd"
					>
						<template #displayedValue>
							{{$t(searchFilter.hasAtd.label)}}
						</template>
						<template #optionItemValue="slotProps">
							{{$t(slotProps.item.label)}}
						</template>
					</t-select>
				</t-form-group>

				<t-form-group>
					<t-select
						:items="references"
						:label="$t('references')"
						:selectedItems="searchFilter.references"
						width="100%"
						relative
						@change="addReferences"
					>
						<template v-slot:displayedValue="{popoverShow}">
							{{ popoverShow ? $t('selectReferences') : $tc('referencesSelected', searchFilter.references.length)}}
						</template>
						<template v-slot:optionItemValue="slotProps">
							{{$t(slotProps.item.id)}}
						</template>
					</t-select>
					<t-tag-container
						v-if="hasItems(searchFilter.references)"
						:items="searchFilter.references"
						@change="setReferences"
					>
						<template v-slot="{item}">
							{{$t(item.id)}}
						</template>
					</t-tag-container>
					<t-text-input
						:value="searchFilter.referencesText"
						:placeholder="$t('searchPlaceholder')"
						@input="setReferencesText"
						@keyup.enter="searchOrders"
					/>
				</t-form-group>
				<t-form-group>
					<t-search-input
						ref="waybillNumbers"
						:label="$t('waybillNumber')"
						:placeholder="$t('allWaybillNumbers')"
						@input="inputs.waybillNumber = $event"
						@change="addWaybillNumber"
						@enter="searchOrders"
					/>
					<t-tag-container
						v-if="hasItems(searchFilter.waybillNumber)"
						:items="searchFilter.waybillNumber"
						@change="setWaybillNumber"
					>
						<template v-slot="{item}">
							{{item.id}}
						</template>
					</t-tag-container>
				</t-form-group>

				<t-form-group>

					<t-checkbox
						:value="searchFilter.mustHaveInboundEdi"
						:checked="searchFilter.mustHaveInboundEdi"
						:label="$t('inboundEdiFilterLabel')"
						style="margin-bottom: 0"
						@change="setMustHaveInboundEdi"
					/>

					<t-search-input
						:value="searchFilter.inboundEdi"
						:placeholder="$t('inboundEdiFilterPlaceholder')"
						@input="setInboundEdi"
						@enter="searchOrders"
					/>
				</t-form-group>

				<t-form-group>
					<t-checkbox
						:value="searchFilter.mustHaveDeviation"
						:checked="searchFilter.mustHaveDeviation"
						:label="$t('deviationFilterLabel')"
						style="margin-bottom: 0"
						@change="setMustHaveDeviation"
					/>
				</t-form-group>

				<t-form-group :title="$t('advancedSearch')">
					<t-button type="bp" iconBefore="add" appearance="minimal">{{$t('addFilter')}}</t-button>
				</t-form-group>
			</div>
		</t-vertical-panel>
	</div>
</template>

<script>
import {
	displayDateFormat, goodsTypesIcons, displayDateFormatter, statuses, eventBus
} from '@/core';
import { mapDynamicState, mapDynamicActions, mapDynamicGetters } from '@/core/mapDynamic';
import { mapState as savedSearchState } from '@/modules/saveLoadPlanningSearch/store/saveLoadPlanningSearch.store.js';
import CustomerSearchInput from '@/modules/customers/CustomerSearchInput';
import GoodsTypesSelect from '@/modules/goodsTypes/GoodsTypesSelect';
import OrderTypesSelect from '@/modules/orderTypes/OrderTypesSelect';
import LocationsCombobox from '@/modules/locations/LocationsCombobox';
import OperationalStatusFormInput from '@/modules/operationalStatus/OperationalStatusFormInput';
import EconomicalStatusesFormInput from '@/modules/economicalStatuses/EconomicalStatusesFormInput';
import OrderSearchFiltersHeader from '@/modules/loadPlanningList/OrderSearch/OrderSearchFiltersHeader';
import TCheckbox from '@/components/evergreen/inputs/TCheckbox';

export default {
	name: 'OrderSearchFilters',
	components: {
		OrderSearchFiltersHeader,
		CustomerSearchInput,
		GoodsTypesSelect,
		OrderTypesSelect,
		LocationsCombobox,
		OperationalStatusFormInput,
		EconomicalStatusesFormInput,
		TCheckbox,
	},
	inject: ['namespace'],
	props: { filtersVisible: Boolean, mapView: Boolean },
	data() {
		return {
			customerValue: '',
			hasAtdItems: [
				{ value: undefined, label: 'showAny' },
				{ value: true, label: 'onlyPickedUp' },
				{ value: false, label: 'notPickedUp' },
			],
			references: [
				{ id: 'consigneeReference' },
				{ id: 'customersReference' },
				{ id: 'poReference' },
				{ id: 'sendersReference' },
			],
			inputs: {
				searchAreas: '',
				fromDespatchParty: '',
				toDeliveryParty: '',
				customer: '',
				waybillNumber: '',
				inboundEdi: '',
			},
			fitDespatchPartyToTrip: false,
			fitDeliveryPartyToTrip: false
		};
	},
	computed: {
		...mapDynamicState('computedStoreNamespace',[
			'searchFilter',
			'ordersLoading',
			'loadedSearch',
			'lockMap',
			'dateTypes'
		]),
		...mapDynamicGetters('computedLoadPlanningStoreNamespace', ['tripDetails']),
		...savedSearchState(['savedSearches']),
		computedStoreNamespace() {
			return `loadPlanning/${this.namespace.id}/orderSearch`;
		},
		computedLoadPlanningStoreNamespace() {
			return `loadPlanning/${this.namespace.id}`;
		},
		displayDateFormat() {
			return displayDateFormat;
		},
		orderSearchText() {
			return this.ordersLoading ? this.$t('loading') : this.$t('search');
		},
	},
	watch: {
		tripDetails: {
			async handler(newVal, oldVal) {
				if (newVal && oldVal && newVal.id === oldVal.id) return;
				if (this.fitDespatchPartyToTrip)
					await this.updateFitDespatchToTrip({ fit: this.fitDespatchPartyToTrip, trip: newVal });
				if (this.fitDeliveryPartyToTrip)
					await this.updateFitDeliveryToTrip({ fit: this.fitDeliveryPartyToTrip, trip: newVal });

				if (this.fitDespatchPartyToTrip || this.fitDeliveryPartyToTrip)
					this.searchOrders();
			}
		}
	},
	created() {
		eventBus.$on('loadPlanningOrderSearch', this.searchOrders);
	},
	mounted() {
		document.addEventListener('keyup', this.onKeyup, { passive: true, capture: true });

		let fitDespatch = localStorage.getItem(`${this.computedStoreNamespace}/fitDespatchPartyToTrip`);
		if (fitDespatch === 'true')
			this.onChangeFitDespatchPartyToTrip(true, false);

		let fitDelivery = localStorage.getItem(`${this.computedStoreNamespace}/fitDeliveryPartyToTrip`);
		if (fitDelivery === 'true')
			this.onChangeFitDeliveryPartyToTrip(true, false);
	},
	beforeDestroy() {
		document.removeEventListener('keyup', this.onKeyup, { capture: true });
	},
	methods: {
		...mapDynamicActions('computedLoadPlanningStoreNamespace', ['fetchOrders',]),
		...mapDynamicActions('computedStoreNamespace',[
			'loadSavedSearch',
			'setValue',
			'setSearchFilterDateType',
			'setSearchFilterDateFrom',
			'setSearchFilterDateTo',
			'addSearchAreas',
			'addSearchAreasString',
			'setSearchAreas',
			'addFromDespatchParty',
			'addFromDespatchPartyString',
			'setFromDespatchParty',
			'addToDeliveryParty',
			'addToDeliveryPartyString',
			'setToDeliveryParty',
			'addCustomer',
			'addCustomerString',
			'setCustomer',
			'addGoodsType',
			'setGoodsType',
			'addOrderTypes',
			'setOrderTypes',
			'addEconomicalStatus',
			'setEconomicalStatus',
			'addOrderStatus',
			'setOrderStatus',
			'addInputTagsOnSearch',
			'addReferences',
			'setReferences',
			'setReferencesText',
			'setPlanned',
			'setHasAtd',
			'addWaybillNumber',
			'setWaybillNumber',
			'changeTagOpCode',
			'changeTagOpCodeBetweenNotAndOr',
			'setMustHaveInboundEdi',
			'setInboundEdi',
			'setMustHaveDeviation',
			'updateFitDespatchToTrip',
			'updateFitDeliveryToTrip'
		]),
		async searchOrders() {
			this.addInputTagsOnSearch(this.inputs);
			this.$refs.searchAreas.clearInput();
			this.$refs.fromDespatchParty.clearInput();
			this.$refs.toDeliveryParty.clearInput();
			this.$refs.customer.clearInput();
			this.performFetchOrders();
		},
		async performFetchOrders() {
			try {
				await this.fetchOrders();
			} catch (e) {
				this.$notify({
					type: 'error',
					title: this.$t('failedToFetch')
				});
			}
		},
		onSelectSearchArea(location) {
			
			if (typeof location === 'string') {
				this.addSearchAreasString(location);
				
			} else {
				this.addSearchAreas(location);
			}
		},
		onSelectDespatchParty(location) {
			
			if (typeof location === 'string') {
				this.addFromDespatchPartyString(location);
				
			} else {
				this.addFromDespatchParty(location);
			}
		},
		onSelectDeliveryParty(location) {
			
			if (typeof location === 'string') {
				this.addToDeliveryPartyString(location);
				
			} else {
				this.addToDeliveryParty(location);
			}
		},
		hasItems(array) {
			return array && array.length > 0;
		},
		onLoadSavedSearch(item) {
			if (!item) return;
			if (item.id === -1) {
				this.$router.push({
					name: this.mapView ? 'loadPlanningMap' : 'loadPlanningList',
				});
			} else {
				this.$router.push({
					name: this.mapView ? 'savedLoadPlanningMap' : 'savedLoadPlanningList',
					params: { searchId: item.id }
				});
			}
		},
		getGoodsTypeIcon(goodsType) {
			return goodsTypesIcons(goodsType);
		},
		onListView() {
			localStorage.setItem(`loadPlanning/${this.namespace.id}/defaultView`, 'list');
			if (this.namespace.id === -1)
				this.$router.push({ name: 'loadPlanningList' });
			else
				this.$router.push({
					name: 'savedLoadPlanningList',
					params: { searchId: this.namespace.id }
				});
		},
		onMapView() {
			localStorage.setItem(`loadPlanning/${this.namespace.id}/defaultView`, 'map');
			if (this.namespace.id === -1)
				this.$router.push({ name: 'loadPlanningMap' });
			else
				this.$router.push({
					name: 'savedLoadPlanningMap',
					params: { searchId: this.namespace.id }
				});
		},
		formatDate(date) {
			return displayDateFormatter(date);
		},
		onKeyup(e) {
			if (e.altKey && e.key === '1') this.$refs.firstInput.focus();
		},
		getStatusText(status) {
			return this.$t(statuses.operational(status));
		},
		getStatusColor(status) {
			return statuses.color(status);
		},
		getEconomicalStatus(value) {
			return this.$t(statuses.economical(value));
		},
		getEconomicalStatusColor(value) {
			return statuses.economicalStatusColor(value);
		},
		async onChangeFitDespatchPartyToTrip(value, search = true) {
			localStorage.setItem(`${this.computedStoreNamespace}/fitDespatchPartyToTrip`, value);
			this.fitDespatchPartyToTrip = value;
			await this.updateFitDespatchToTrip({ fit: value, trip: this.tripDetails });
			if (search) this.searchOrders();
		},
		async onChangeFitDeliveryPartyToTrip(value, search = true) {
			localStorage.setItem(`${this.computedStoreNamespace}/fitDeliveryPartyToTrip`, value);
			this.fitDeliveryPartyToTrip = value;
			await this.updateFitDeliveryToTrip({ fit: value, trip: this.tripDetails });
			if (search) this.searchOrders();
		}
	},
};
</script>

<style scoped>
.order-search-form {
	display: flex;
	flex-direction: row;
	padding-top: 0px;
	width: auto;
	box-sizing: border-box;
	height: 100%;
	flex-shrink: 0;
	overflow:hidden;
}

.loadplanning-inner-menu-bar {
	display: flex;
	flex-direction: column;
	width: 30px;
	padding-top: 9px;
	padding-left: 4px;
	padding-right: 4px;
	box-sizing: content-box;
	background-color: #f5f6f7;
}

.loadplanning-inner-menu-bar > * {
	margin-bottom: 10px;
	position: relative;
}

.loadplanning-inner-menu-bar >>> * {
	width: 100%;
	text-align: center;
}

.loadplanning-inner-menu-bar >>> svg {
	position: absolute;
	left: 52%;
	transform: translateX(-50%);
}



.order-search {
	background: white;
	width: 250px;
}
.order-search .order-search-header {
	display:flex;
	align-items: center;
	height: 100%;
}
.order-search .order-search-sub-header {
	display:inline-grid;
	grid-auto-flow: column;
	grid-auto-columns: 1fr;
	column-gap: 20px;
	padding: 0px 15px;
	height: 100%;
	width: 100%;
	align-items: center;
}
.order-search .order-search-content {
	background: white;
	box-sizing: border-box;
	min-height: 100%;
	padding: 10px 10px 10px 10px;
	display: grid;
	grid-auto-rows: minmax(min-content, max-content);
	grid-template-columns: 100%;
	row-gap: 20px;
	margin-bottom: 20px;
}
</style>
